import NotFound from './views/404.vue'
import Home from './views/Home.vue'

import GisShow from './views/realData/GisShow.vue'
import NormalMap from './views/realData/NormalMap.vue'
import BIWeb from './views/realData/BIWeb.vue'
import indexPage from './views/realData/indexPage.vue'
import NoiseMap from './views/realData/NoiseMap.vue'
import Rose from './views/realData/Rose.vue'

import Factor from './views/device/Factor.vue'
import DeviceType from './views/device/DeviceType.vue'
import Device from './views/device/Device.vue'
import Project from './views/device/Project.vue'
import DeviceEvent from './views/device/DeviceEvent.vue'
import SelfInspectionRecords from './views/device/SelfInspectionRecords.vue'

import User from './views/sysManage/User.vue'
import Role from './views/sysManage/Role.vue'
import Login from './views/sysManage/Login.vue'
import OptLog from './views/sysManage/OptLog.vue'
import Storage from './views/sysManage/Storage.vue'
import VersionHistory from './views/sysManage/VersionHistory.vue'
import CheckDigitMa from './views/sysManage/CheckDigitMa.vue'
import SingleSignOn from './views/sysManage/SingleSignOn.vue'

import FacAnalytical from './views/charts/FactorAnalytical.vue'
import MinuteData from'./views/charts/MinuteData.vue'
import HourData from'./views/charts/HourData.vue'
import DayData from'./views/charts/DayData.vue'
import OutLimitData from './views/charts/OutLimitData.vue'
import ExceptionalData from './views/charts/ExceptionalData.vue'
import Analy from './views/charts/Analy.vue'
import MonthData from'./views/charts/MonthData.vue'
import QuarterData from'./views/charts/QuarterData.vue'
import YearData from'./views/charts/YearData.vue'
import DataCollectionRate from'./views/charts/DataCollectionRate.vue'
import DeviceAddData from'./views/charts/DeviceAddData.vue'
import SpectrumData from'./views/charts/SpectrumData.vue'

import RecordingQuery from'./views/chartsNoise/RecordingQuery.vue'
import Spectrum from'./views/chartsNoise/Spectrum.vue'
import ChooseDay from'./views/chartsNoise/ChooseDay.vue'
import ComplianceRate from'./views/chartsNoise/ComplianceRate.vue'
import ExcessiveCount from'./views/chartsNoise/ExcessiveCount.vue'
import SoundSourceIdentification from'./views/chartsNoise/SoundSourceIdentification.vue'
import SoundSourceLocalization from'./views/chartsNoise/SoundSourceLocalization.vue'
import VoiceprintRecognition from'./views/chartsNoise/VoiceprintRecognition.vue'
import SoundManage from'./views/chartsNoise/SoundManage.vue'
import DataDetail from'./views/chartsNoise/DataDetail.vue'
import TimeDistributionChart from'./views/chartsNoise/TimeDistributionChart.vue'
import NoiseCalendar from'./views/chartsNoise/NoiseCalendar.vue'

import YNTakePhoto from'./views/chartsNoise/YNTakePhoto.vue'

import DataExport from'./views/internally/DataExport.vue'
import DataAddJL from'./views/internally/DataAddJL.vue'

import Hour from './views/form/hour.vue'
import Week from './views/form/week.vue'
import Month from './views/form/month.vue'
import Day from'./views/form/day.vue'
import Season from'./views/form/Season.vue'
import Year from'./views/form/year.vue'
import FormFactor from './views/form/formFactor.vue'
import OrderNumQuery from './views/form/OrderNumQuery.vue'
import OrderRateQuery from './views/form/OrderRateQuery.vue'
import FormCustom from './views/form/FormCustom.vue'
import DayStat from './views/form/dayStat.vue'
import OrderRateCalc from './views/form/OrderRateCalc.vue'

import ReviewWay from './views/review/ReviewWay.vue'
import ReviewSet from './views/review/ReviewSet.vue'
import ReviewData from './views/review/ReviewData.vue'
import ReviewCondition from './views/review/ReviewCondition.vue'
import ReviewCalendar from './views/review/ReviewCalendar.vue'
import ReviewDataCompare from './views/review/ReviewDataCompare.vue'

import DataManagement from './views/uploadNoise/DataManagement.vue'
import DataComparison from './views/uploadNoise/DataComparison.vue'
import DataQuery from './views/uploadNoise/DataQuery.vue'

import UserDevops from './views/operation/UserDevops.vue'
import DeviceCalibration from './views/operation/DeviceCalibration.vue'
import CalibrationRecord from './views/operation/CalibrationRecord.vue'
import MaintenanceRecord from './views/operation/MaintenanceRecord.vue'
import MaintenanceStatus from './views/operation/MaintenanceStatus.vue'
import DailyMaintRecords from './views/operation/DailyMaintRecords.vue'
import DeviceInspectionRecord from './views/operation/DeviceInspectionRecord.vue'

// 机场噪声
import FlightEvent from './views/flight/FlightEvent.vue'
import FlightSet from './views/flight/FlightSet.vue'
import FlightDayForm from './views/flight/FlightDayForm.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/singleSignOn',
        component: SingleSignOn,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '实时数据',
        code:"realData", 
        iconCls: 'fa fa-tachometer fa-lg',//图标样式class
        children: [
            { path: '/gisShow', code:"gisShow", component: GisShow, name: '站点地图' ,meta: {noCache: true }},
            { path: '/normalMap', code:"normalMap", component: NormalMap, name: '实时数据' ,meta: {noCache: true }},
            { path: '/selfInspectionRecords',code:"selfInspectionRecords",  component: SelfInspectionRecords, name: '自检记录' },
            { path: '/deviceEvent', code:"deviceEvent", component: DeviceEvent, name: '异常报警' },
            { path: '/recordingQuery',code:"recordingQuery",  component: RecordingQuery, name: '事件录音' },
            { path: '/dataCollectionRate',code:"dataCollectionRate",  component: DataCollectionRate, name: '采集率统计' },
            { path: '/BIWeb', code:"BIWeb", component: BIWeb, name: '噪声大屏' },

            { path: '/rose', code:"rose", component: Rose, name: '玫瑰图' },
            { path: '/noiseMap', code:"noiseMap", component: NoiseMap, name: '噪声地图' },

            { path: '/minuteData',code: 'minuteData',  component: MinuteData, name: '分钟数据' },
            { path: '/hourData',code: 'hourData',  component: HourData, name: '小时数据' },
            { path: '/dayData',code: 'dayData',  component: DayData, name: '天数据' },
            { path: '/monthData',code: 'MonthData',  component: MonthData, name: '月数据' },
            { path: '/quarterData',code: 'QuarterData',  component: QuarterData, name: '季度数据'},
            { path: '/yearData',code: 'YearData',  component: YearData, name: '年数据' },
            { path: '/deviceAddData',code: 'DeviceAddData',  component: DeviceAddData, name: '数据补传' },
        
            { path: '/factorAnalytical',code:"factorAnalytical",  component: FacAnalytical, name: '对比分析' },
            { path: '/analy',code: 'analy',  component: Analy, name: '同环比分析' },
            { path: '/chooseDay',code:"chooseDay",  component: ChooseDay, name: '自选统计' },
            { path: '/complianceRate',code:"complianceRate",  component: ComplianceRate, name: '达标率统计' },
            { path: '/exceptionalData',code: 'exceptionalData',  component: ExceptionalData, name: '异常数据' },
            { path: '/outLimitData',code: 'outLimitData',  component: OutLimitData, name: '超标数据' },
            { path: '/spectrumData',code: 'spectrumData',  component: SpectrumData, name: '频谱数据' },

            { path: '/excessiveCount',code:"excessiveCount",  component: ExcessiveCount, name: '超标统计' },
            { path: '/recordingList',code:"recordingList",  component: RecordingQuery, name: '噪声录音' },
            { path: '/soundSourceIdentificationMa',code:"soundSourceIdentificationMa",  component: SoundSourceIdentification, name: '声源识别' },
            { path: '/SoundSourceLocalizationMa',code:"SoundSourceLocalizationMa",  component: SoundSourceLocalization, name: '声源定位' },//深圳微纳
            { path: '/voiceprintRecognition',code:"VoiceprintRecognition",  component: VoiceprintRecognition, name: '声源定位' },//伏羲8麦
            { path: '/YNTakePhoto',code:"YNTakePhoto",  component: YNTakePhoto, name: '声源定位' },//泉州声学相机
            { path: '/spectrumNoise', code:"spectrumNoise", component: Spectrum, name: '频谱分析'  ,meta: {noCache: true }},
            { path: '/noiseCalendar', code:"noiseCalendar", component: NoiseCalendar, name: '噪声日历' },
        
            { path: '/dataQuery',code:"dataQuery",  component: DataQuery, name: '手工数据查询' },
            { path: '/dataManagement',code:"dataManagement",  component: DataManagement, name: '手工数据管理' },
            { path: '/dataComparison',code:"dataComparison",  component: DataComparison, name: '数据比对' },

            { path: '/dataDetail',code:"dataDetail",  component: DataDetail, name: '数据说明' },

            { path: '/reviewWay', code:"reviewWay", component: ReviewWay, name: '审核方式' },
            { path: '/reviewSet', code:"reviewSet", component: ReviewSet, name: '审核配置' },
            { path: '/reviewDataMa',code:"reviewDataMa",  component: ReviewData, name: '数据审核' },
            { path: '/reviewCalendar',code:"reviewCalendar",  component: ReviewCalendar, name: '审核日历' },
            { path: '/reviewDataCompare',code:"reviewDataCompare",  component: ReviewDataCompare, name: '数据比对' },
            { path: '/reviewCondition',code:"reviewCondition",  component: ReviewCondition, name: '条件设置' },
            
            { path: '/orderNumQuery', code: 'orderNumQuery', component: OrderNumQuery, name: '噪声排名' }, 
            { path: '/orderRateQuery', code: 'orderRateQuery', component: OrderRateQuery, name: '达标率排名' }, 
            { path: '/orderRateCalc', code: 'orderRateCalc', component: OrderRateCalc, name: '达标率计算' }, 
            { path: '/formDay', code: 'formDay', component: Day, name: '日报' },
            { path: '/dayStat', code: 'dayStat', component: DayStat, name: '日报(统计版)' },
            { path: '/formHour', code: 'formHour', component: Hour, name: '时报' },
            { path: '/formWeek', code: 'formWeek', component: Week, name: '周报' },
            { path: '/formMonth',code: 'formMonth', component: Month, name: '月报' },
            { path: '/formSeason',code: 'formSeason', component: Season, name: '季报' },
            { path: '/formYear', code: 'formYear', component: Year, name: '年报' },
            { path: '/formCustom', code: 'formCustom', component: FormCustom, name: '自定义报表' },
            { path: '/formFactor',code: 'formFactor', component: FormFactor, name: '报表设置' },
        
            { path: '/dataExport', code:"dataExport", component: DataExport, name: '数据分析与导出' },
            { path: '/dataAddJL', code:"dataAddJL", component: DataAddJL, name: '吉林数据补传' },

            { path: '/factorMa', code:"factorMa", component: Factor, name: '因子管理',meta: {noCache: true } },
            { path: '/deviceTypeMa', code:"deviceTypeMa", component: DeviceType, name: '设备类型管理',meta: {noCache: true } },
            { path: '/projectMa',code:"projectMa",  component: Project, name: '项目管理',meta: {noCache: true } },
            { path: '/deviceMa', code:"deviceMa", component: Device, name: '设备管理',meta: {noCache: true } },
        
            { path: '/userDevops', code:"userDevops", component: UserDevops, name: '运维人员' },
            { path: '/deviceCalibration', code:"deviceCalibration", component: DeviceCalibration, name: '校准设备' },
            { path: '/calibrationRecord',code:"calibrationRecord",  component: CalibrationRecord, name: '校准器送检记录' },
            { path: '/maintenanceStatus',code:"maintenanceStatus",  component: MaintenanceStatus, name: '运维状态' },
            { path: '/maintenanceRecord',code:"maintenanceRecord",  component: MaintenanceRecord, name: '运维记录' },
            { path: '/deviceInspectionRecord',code:"deviceInspectionRecord",  component: DeviceInspectionRecord, name: '设备送检记录' },

            { path: '/storage',code:"storage",  component: Storage, name: '存储管理' },

            { path: '/userMa',code:"userMa",  component: User, name: '用户管理',meta: {noCache: true } },
            { path: '/roleMa',code:"roleMa",  component: Role, name: '角色管理' ,meta: {noCache: true }},
            { path: '/soundManage',code:"soundManage",  component: SoundManage, name: '声源管理' },
            { path: '/optLog',code:"optLog",  component: OptLog, name: '操作日志查看' },
            { path: '/versionHistory',code:"versionHistory",  component: VersionHistory, name: '更新记录' },

            { path: '/indexPage',code:"indexPage",  component: indexPage, name: '首页'},
            { path: '/timeDistributionChart',code:"timeDistributionChart",  component: TimeDistributionChart, name: '噪声趋势图' },
            { path: '/dailyMaintRecords',code:"dailyMaintRecords",  component: DailyMaintRecords, name: '每日运维记录' },
            { path: '/checkDigitMa',code:"checkDigitMa",  component: CheckDigitMa, name: '数据转发管理' },

            // 机场噪声
            { path: '/flightEvent',code:"flightEvent",  component: FlightEvent, name: '飞行事件'},
            { path: '/flightSet',code:"flightSet",  component: FlightSet, name: '机场噪声配置'},
            { path: '/flightDayForm',code:"flightDayForm",  component: FlightDayForm, name: '机场噪声日报'},
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js